import { API_HOST } from "../configs/api";
import { getRequest, postRequest } from "./request";

// list existing fonts
const updateFontsView = async (editor, pathName, setMsg, setError) => {
  try {
    const response = await getRequest(`assets/${pathName}/fonts`);
    const fontsHolder = document.getElementById("fonts-list-group1");

    if (response.data.isSuccess) {
      let list = "";
      response.data.fonts.forEach((fontObj) => {
        if (fontObj.isShared === false) {
          list += `<button data-name="${fontObj.fontName}" style="display:inline-block;margin-right:10px;margin-top:10px;background-color: white;border-color: rgba(0,0,0,0.23);border-radius: 5px;">
          <span>${fontObj.fontName}</span>
          <span class="delete-font" style="margin-left: 15px;font-weight:bold;">X</span>
        </button>`;
        } else {
          list += `<button data-name="${fontObj.fontName}" style="display:inline-block;margin-right:10px;margin-top:10px;background-color: white;border-color: rgba(0,0,0,0.23);border-radius: 5px;">
          <span>${fontObj.fontName}</span>
          <span class="fa fa-share-alt" style="margin-left: 15px;opacity:0.5"></span>
        </button>`;
        }
      });
      // <span class="delete-font" style="margin-left: 15px;font-weight:bold;${pathName.includes("imports") ? "display: none;" : ""}">X</span>
      fontsHolder.innerHTML = list;
    } else {
      fontsHolder.innerHTML = `<li class="list-group-item d-flex text-danger">
          No fonts available !!
        </li>`;
    }
  } catch (error) {
    setError(true);
    setMsg(error);
  }

  let delFont = document.querySelectorAll("span.delete-font");
  delFont.forEach((el) => {
    el.addEventListener("click", async (e) => {
      if (!window.confirm("Are you sure,you want to delete this Font?")) return;

      try {
        let fontName = e.target.parentNode.getAttribute("data-name");
        e.target.parentNode.remove();

        let formData = new FormData();
        formData.append("fontName", fontName);
        const response = await postRequest(
          `assets/${pathName}/deletefonts`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (response.data.isSuccess) {
          const [fileName, fileExtension] = fontName.split(".");

          if (response.data.sharedKmFonts.indexOf(fontName) === -1) {
            const fontFamily = editor.StyleManager.getProperty(
              "typography",
              "font-family"
            );
            var data = { value: fileName, name: fileName };
            var fontFamilydata = fontFamily.get("options");
            let newfontFamilydata = [];
            fontFamilydata.forEach((value) => {
              if (JSON.stringify(value) !== JSON.stringify(data)) {
                newfontFamilydata.push(value);
              }
            });
            fontFamily.set("options", newfontFamilydata);
          }

          let type = fileExtension === "ttf" ? "truetype" : "opentype";
          let fontCss = `@font-face{font-family:${fileName};src:url("${API_HOST}assets/${pathName}/${response.data.srcUrl}${fontName}") format(${type});font-weight:normal;font-style:normal;font-display:fallback;}`;
          // let fontCss1 = `font-family:${fileName};`;
          // let fontCss1= `/\bfont-family:${fileName}\b(?![\w-])/g`
          let cssCode = editor.getCss();
          let cssCode1 = cssCode
            .replaceAll(fontCss, "")
            // .replaceAll(fontCss1, "")
            .replaceAll(`*{box-sizing:border-box;}body{margin:0;}`, "");

          editor.setStyle(cssCode1);

          // removeFontFamilyStyleOnFontDelete(editor, {
          //   styleProperty: "font-family",
          //   styleValue: fileName,
          // });
          // cssCode1 = editor.getCss();
          // editor.setStyle(cssCode1);

          editor.store();

          // let ckeditorFontFamily = window.CKEDITOR.config.font_names;
          // ckeditorFontFamily = ckeditorFontFamily.replace(";" + fileName, "");
          // window.CKEDITOR.config.font_names = ckeditorFontFamily;
        } else {
          if (response.data.msg) {
            setError(true);
            setMsg(response.data.msg);
          }
        }
      } catch (error) {
        setError(true);
        setMsg(error);
      }
    });
  });
};

const updateFontsRepoView = async (editor, pathName, setMsg, setError) => {
  let matchingFontsCount = 0;
  try {
    const response = await getRequest(`assets/fontContent`);
    const fontsHolder = document.getElementById("fonts-list-group");
    if (response.data.isSuccess) {
      let list = "";
      response.data.fonts.forEach((fontObj) => {
        matchingFontsCount++;
        list += `<button data-name="${fontObj.name}" style="display:inline-block;margin-right:10px;margin-top:10px;background-color: white;border-color: rgba(0,0,0,0.23);border-radius: 5px;">
          <span>${fontObj.name}</span>
          <span class="add-font fa fa-plus" style="margin-left: 15px;"></span>
        </button>`;
      });
      fontsHolder.innerHTML = list;
    } else {
      fontsHolder.innerHTML = `<li class="list-group-item d-flex text-danger">
          No fonts available !!
        </li>`;
    }
  } catch (error) {
    setError(true);
    setMsg(error);
  }

  const fontCountSpan = document.querySelector("#font-list #font-repo-count");
  fontCountSpan.innerHTML = `${matchingFontsCount} font${
    matchingFontsCount === 1 ? "" : "s"
  }`;
  /*-------------------Font repo search---------------------------*/
  const fontRepoSearchInput = document.querySelector(
    "#font-list #font-repo-search"
  );
  fontRepoSearchInput.addEventListener("input", (e) => {
    matchingFontsCount = 0;
    const searchValue = e.target.value.trim();
    const fontRepoButtons = document.querySelectorAll(
      "#font-list #fonts-list-group button"
    );

    fontRepoButtons.forEach((fontButton) => {
      const attributeName = "data-name";
      const fontName = fontButton.getAttribute(attributeName);
      if (fontName.toLowerCase().includes(searchValue.toLowerCase())) {
        matchingFontsCount++;
        fontButton.style.display = "inline-block";
      } else {
        fontButton.style.display = "none";
      }
    });
    fontCountSpan.innerHTML = `${matchingFontsCount} font${
      matchingFontsCount === 1 ? "" : "s"
    }`;
  });
  /*--------------------------------------------------------------*/

  let addFont = document.querySelectorAll("span.add-font");
  addFont.forEach((el) => {
    el.addEventListener("click", async (e) => {
      try {
        let fontName = e.target.parentNode.getAttribute("data-name");
        let formData = new FormData();
        formData.append("fontName", fontName);
        const response = await postRequest(
          `assets/${pathName}/fonts`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (response.data.isSuccess) {
          updateFontsView(editor, pathName, setMsg, setError);

          const [fileName, fileExtension] = fontName.split(".");

          const fontFamily = editor.StyleManager.getProperty(
            "typography",
            "font-family"
          );

          const fontExists = [...fontFamily.get("options")].some(
            (fontObj) => fontObj.name === fileName
          );

          if (fontExists === false) {
            fontFamily.set("options", [
              ...fontFamily.get("options"),
              { value: fileName, name: fileName },
            ]);
          }

          let type = fileExtension === "ttf" ? "truetype" : "opentype";
          let fontCss = `@font-face{font-family:${fileName};src:url("${API_HOST}assets/${pathName}/${response.data.srcUrl}${fontName}") format(${type});font-weight:normal;font-style:normal;font-display:fallback;}`;
          if (editor.getCss().indexOf(fontCss) === -1) {
            editor.Css.addRules(fontCss);
          }
          editor.store();
          // let ckeditorFontFamily = window.CKEDITOR.config.font_names;
          // let fontArray = ckeditorFontFamily.split(";");
          // if (fontArray.indexOf(fileName) == -1) {
          //   ckeditorFontFamily = ckeditorFontFamily + ";" + fileName;
          // }
          // window.CKEDITOR.config.font_names = ckeditorFontFamily;
        } else {
          if (response.data.msg) {
            setError(true);
            setMsg(response.data.msg);
          }
        }
      } catch (error) {
        setError(true);
        setMsg(error);
      }
    });
  });
  updateFontsView(editor, pathName);
};

export const updateFontFamily = async (editor, pathName, setMsg, setError) => {
  try {
    const response = await getRequest(`assets/${pathName}/fonts`);

    // let ckeditorFontFamily = window.CKEDITOR.config.font_names;

    if (response.data.isSuccess) {
      response.data.fonts.forEach((fontObj) => {
        const [fileName, fileExtension] = fontObj.fontName.split(".");
        const fontFamily = editor.StyleManager.getProperty(
          "typography",
          "font-family"
        );
        const fontExists = [...fontFamily.get("options")].some(
          (fontObj) => fontObj.name === fileName
        );

        if (fontExists === false) {
          fontFamily.set("options", [
            ...fontFamily.get("options"),
            { value: fileName, name: fileName },
          ]);
        }

        if (fontObj.isShared === false) {
          let type = fileExtension === "ttf" ? "truetype" : "opentype";

          let fontCss = `@font-face{font-family:${fileName};src:${fontObj.srcUrl} format(${type});font-weight:normal;font-style:normal;font-display:fallback;}`;
          if (editor.getCss().indexOf(fontCss) === -1) {
            editor.Css.addRules(fontCss);
          }
        }

        //   let fontArray = ckeditorFontFamily.split(";");
        //   if (fontArray.indexOf(fileName) == -1) {
        //     ckeditorFontFamily = ckeditorFontFamily + ";" + fileName;
        //   }
      });

      // window.CKEDITOR.config.font_names = ckeditorFontFamily;
    } else {
      if (response.data.msg) {
        setError(true);
        setMsg(response.data.msg);
      }
    }
  } catch (error) {
    setError(true);
    setMsg(error);
  }
};

export const createUploadFontModal = async (
  editor,
  pathName,
  setMsg,
  setError
) => {
  const fontDiv = document.querySelector("#upload-font");

  if (fontDiv.classList.contains("d-none")) {
    fontDiv.classList = "";
    fontDiv.innerHTML = "";
  }

  let modal = `<div class="fade modal show" role="dialog" aria-modal="true" style="display: block;">
    <div style="padding-right: 17px; display: block;" class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title h5">Font Settings</div>&nbsp
          <button class="btn-close" aria-label="close"></button>
        </div>
        <div class="modal-body">
          <div style="height: 600px" id="upload-container"  style="overflow: scroll">
            <div class="row">
              <div class="col" style="border-right: 1px solid #ccc; height: 280px">
                <form>
                  <div class="form-group">
                    <label for="fontFile">Select font</label>
                    <input type="file" class="form-control" name="fontFile" id="fontFile" multiple/>
                    <small class="form-text text-muted">Fonts selected for this design will be not available for other designs</small>
                  </div>
                  <div class="form-group">
                    <button id="submit-fonts" class="btn btn-primary">Upload Font</button>
                  </div>
                </form>
              </div>
              <div class="col" style="height: 280px">
                <div id="font-list1">
                  <h6>Custom fonts for this design</h6>                  
                  <div id="fonts-list-group1" style="height: 260px; overflow: scroll"></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div id="font-list">
                   <div class="row g-3 align-items-center">
                        <div class="col-auto">
                            <span class="h6">Font Repository</span>
                        </div>
                        <div class="col-auto">
                            <input class="form-control form-control-sm" type="search" id="font-repo-search" />
                        </div>
                        <div class="col-auto">
                            <span id="font-repo-count">0 Fonts</span>
                        </div>
                   </div>
                   <div id="fonts-list-group" style="height: 285px;overflow: scroll"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </div>
  </div>
  <div class="fade modal-backdrop show"></div>`;

  fontDiv.innerHTML = modal;

  // module toggle[show/close] handler
  const closeBtn = document.querySelector("#upload-font .btn-close");
  closeBtn.addEventListener("click", () => {
    fontDiv.className = "d-none";
  });

  // upload handler
  const submitButton = document.querySelector("#submit-fonts");
  submitButton.addEventListener("click", async (e) => {
    e.preventDefault();
    let fileInput = document.querySelector("#fontFile");

    if (fileInput.value === "") {
      setError(true);
      setMsg("Please select font file!!");
      return;
    }

    let formData = new FormData();
    for (var fileData in fileInput.files) {
      if (fileData !== "length" && fileData !== "item") {
        formData.append("fontFile", fileInput.files[fileData]);
      }
    }
    try {
      const response = await postRequest(`assets/createFont`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      response.data.forEach((data) => {
        if (data.isSuccess) {
          updateFontsRepoView(editor, pathName, setMsg, setError);
          fileInput.value = "";
        } else {
          if (data.msg) {
            setError(true);
            setMsg(data.msg);
          }
        }
      });
    } catch (error) {
      setError(true);
      setMsg(error);
    }
  });
  updateFontsRepoView(editor, pathName);
};
